export const NO_DEFAULT_SELECTED_FILTER_VALUE = "__none";

export const getDefaultSelectedValues = (
  filterValue: string | number | boolean | undefined,
  allValues: string[]
): string[] => {
  if (!allValues.length) {
    return [];
  }

  if (filterValue === NO_DEFAULT_SELECTED_FILTER_VALUE) {
    return [];
  }

  if (filterValue && filterValue !== "all") {
    const filterValues = String(filterValue).split("-");
    return filterValues.filter((value) => allValues.includes(value));
  }

  return allValues;
};

export const serializeDefaultSelectedValues = (
  selectedValues: string[],
  allValues: string[]
): string | undefined => {
  const selectedValueSet = new Set(selectedValues);
  const orderedValues = allValues.filter((value) =>
    selectedValueSet.has(value)
  );

  if (orderedValues.length === allValues.length) {
    return undefined;
  }

  return orderedValues.length > 0
    ? orderedValues.join("-")
    : NO_DEFAULT_SELECTED_FILTER_VALUE;
};

export const isDefaultSelectedFilterMatch = (
  filterValue: string | number | boolean | undefined,
  value: string
): boolean => {
  if (!filterValue || filterValue === "all") {
    return true;
  }

  if (filterValue === NO_DEFAULT_SELECTED_FILTER_VALUE) {
    return false;
  }

  return String(filterValue).split("-").includes(value);
};
